import { useEffect } from 'react'

export interface ToastMsg {
  text: string
  kind?: 'info' | 'error'
}

export function Toast({ msg, onDismiss }: { msg: ToastMsg; onDismiss: () => void }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 6000)
    return () => clearTimeout(t)
  }, [msg, onDismiss])

  return (
    <div
      className={`toast${msg.kind === 'error' ? ' error' : ''}`}
      role={msg.kind === 'error' ? 'alert' : 'status'}
      aria-live={msg.kind === 'error' ? 'assertive' : 'polite'}
    >
      <span>{msg.text}</span>
      <button className="btn btn-ghost" style={{ color: '#fff' }} onClick={onDismiss} aria-label="Dismiss">
        ✕
      </button>
    </div>
  )
}
